<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :title="$t('SshKeyManagement_Dialog_ImportTitle')"
    :before-close="onClose"
    width="600px"
    center
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item :label="$t('SshKeyManagement_Field_Name')" prop="name">
        <el-input
          v-model="form.name"
          :placeholder="$t('SshKeyManagement_Field_Name_Placeholder')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('SshKeyManagement_Field_PrivateKey')"
        prop="private_key"
      >
        <el-input
          type="textarea"
          :rows="10"
          v-model="form.private_key"
          :placeholder="$t('SshKeyManagement_Field_PrivateKey_Placeholder')"
          spellcheck="false"
        />
        <div class="field-hint">
          {{ $t('SshKeyManagement_Field_PrivateKey_Hint') }}
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="importKey" :loading="loading">
        {{ $t('SshKeyManagement_Button_Import') }}
        <i class="el-icon-upload2"></i>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import RestApi from '@/core/services/RestApi'

/**
 * SSH Key Import Dialog Component
 * Allows importing existing SSH private keys
 */
export default {
  name: 'SshKeyImportDialog',

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      form: {
        name: '',
        private_key: ''
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t('RestForm_FieldIsRequired'),
            trigger: 'blur'
          }
        ],
        private_key: [
          {
            required: true,
            message: this.$t('RestForm_FieldIsRequired'),
            trigger: 'blur'
          }
        ]
      }
    }
  },

  methods: {
    importKey() {
      this.$refs.form.validate(valid => {
        if (!valid) return

        this.loading = true
        RestApi.post(`projects/${this.$store.getters.projectId}/ssh-keys`, {
          name: this.form.name,
          private_key: this.form.private_key
        })
          .then(({ data }) => {
            this.$emit('created', data)
            this.reset()
            this.onClose()
          })
          .catch(error => {
            this.$message({
              message: this.formatErrorMessage(error),
              type: 'error',
              dangerouslyUseHTMLString: true
            })
          })
          .finally(() => {
            this.loading = false
          })
      })
    },

    formatErrorMessage(error) {
      const errors =
        error.response && error.response.data && error.response.data.errors
      if (errors && typeof errors === 'object') {
        const fieldErrors = Object.values(errors)
          .flat()
          .map(msg => `&nbsp;&nbsp;• ${msg.replace(/^\w+__/, '')}`)
          .join('<br>')
        if (error.message && fieldErrors) {
          return `${error.message}<br>${fieldErrors}`
        }
        return fieldErrors || error.message
      }
      return error.message
    },

    reset() {
      this.form.name = ''
      this.form.private_key = ''
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },

    onClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.field-hint {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/ssh/SshKeyImportDialog.vue